var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-wrapper"},[_c('Header',{attrs:{"menus":_vm.menus},on:{"update:activeTab":function($event){_vm.activeTab = $event}}}),_c('SubHeader',{attrs:{"msg":"","currentMenu":this.currentMenu}}),_c('MenuSection',{attrs:{"currentMenu":_vm.currentMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }